// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";


const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: false,
    onClick: null
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          rotate: -45,
          display: true,
          labelString: "Number of Students Qualified"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          autoSkip: false,
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          // callback: function(label) {
          //   console.log(label);
          //   if (/\s/.test(label)) {
          //     if (label.split(" ").length > 2) {
          //       label = label.split(" ");
          //       label[1] = label[0] + " " + label[1];
          //       console.log(label)
          //       label.shift();
          //       console.log(label);
          //       return label;
          //     } else {
          //       return label.split(" ");
          //     }
          //   } else {
          //     return label;
          //   }
          // }
        },
        stacked: false,
        //type: 'linear',
        categoryPercentage: 0.5,
        display: true,
        scaleLabel: {
          //rotate: -45,
          display: true,
          labelString: "Financial Aid"
        }
      }
    ]
  },
  ticks: {
    autoSkip: false,
    maxRotation: 0,
    minRotation: 90
  },
  title: {
    display: false,
    text: "Financial Aid"
  },
  tooltips: {
    callbacks: {
    label: function(tooltipItem){
      return tooltipItem.xLabel + ' students'
    }
  }
  }
};

interface FinancialAidBarChartProps {
  caption: string;
}

class FinancialAidBarChart extends React.Component<FinancialAidBarChartProps> {
  constructor(props: FinancialAidBarChartProps){
    super(props);
  }
  state = {
    //using this as the data
    //dummy data for testing just in case
    labels: ["Work-study",
      "Cal Grant",
      ["University", "need-based grant"],
      ["UCLA need-based", "academic scholarship"],
      "Subsidized loans",
      ["Direct-unsubsidized", "loans"],
      "Parent loan",
      "DREAM Act",
      "CHAFEE Grant",
      ["California Middle", "Class Scholarship"],
      "Pell grant",
      ["Graduate fellowship/", "TA position"],
      "Prefer not to say"],
    borderWidth: 1,
    datasets: [
      {
        data: [47,45,53,19,66,76,49,2,0,19,1, 2, 22],
        //barPercentage:1.0,
        categoryPercentage: 1.0,
        //barThickness: '35',
        backgroundColor: "#48A2D3"
      }
    ]
  };

  
  render() {
    const caption = this.props.caption
    defaults.global.defaultFontColor = "#0a0a0a";

    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Financial Aid
        </div>
        <div
          className={css`
            height: 600px;
            width: 100%;
          `}
        >
          <HorizontalBar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
          </div>
          <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: center;
          `}
        >
            {caption}
        </div>
      </Card>
    );
  }
}

export default FinancialAidBarChart;
